// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"df55b752334be01e7e4d","108":"f03079819f8757c97349","243":"307c1cf31df043fbcfea","682":"010d3484390bfdcb1778","688":"7e1d31234537d9b9ffce","852":"f7674fcc58a539abfecd","872":"f9bf7b626c7e0cf66276"}[chunkId] + ".bundle.js";
};